// Copyright ©️ 2026 eVolve MEP, LLC

/**
 * There are 72 points (pt) in an inch, so this constant can be used to convert between the two units of measurement.
 */
export const PT_PER_INCH = 72;

export const FONT_SIZE_MIN = 1;
export const FONT_SIZE_MAX = 999;
export const FONT_SIZE_CHAR_LIMIT = FONT_SIZE_MAX.toString().length;

export const MARKUP_SIZE_MIN = 1;
export const MARKUP_SIZE_MAX = 999;
export const MARKUP_SIZE_CHAR_LIMIT = MARKUP_SIZE_MAX.toString().length;

export const OPACITY_MIN = 0;
export const OPACITY_MAX = 100;
export const OPACITY_CHAR_LIMIT = OPACITY_MAX.toString().length;
